import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Cookie from 'js-cookie';
import {
    client,
    useEvent,
    useRingSettings,
    isPreviewMode,
    redirectToPromotionalWebsite,
} from '@bizzabo/entities';
import { default as ApiConfig } from 'config';

export async function refreshTokenRequest(eventGroupId: number): Promise<void> {
    await client().post(`${location.origin}/token/refresh?eventGroupId=${eventGroupId}`);
}

const useAuth = (eventUniqueName: string, embedMode: boolean) => {
    const [isAuth, setIsAuth] = useState(false);
    const { data: event, isLoading: isLoadingEvent } = useEvent(eventUniqueName);
    const {
        data: ringSettings,
        isLoading: isLoadingRingSettings,
        isIdle: isIdleRingSettings,
    } = useRingSettings(event?.id, event?.accountId, {
        enabled: !!event,
        retry: 1,
    });
    const isLoading = isLoadingRingSettings || isLoadingEvent || isIdleRingSettings;
    const { search } = useLocation();

    useEffect(() => {
        const checkAuth = async () => {
            if (isLoading) {
                return;
            }

            if (!ringSettings?.available && !embedMode) {
                redirectToPromotionalWebsite(event, search);
                return;
            }

            // Preview cookie let us enter the ring without enabled it
            const isPreview = isPreviewMode(event.groupId);
            if (!isPreview && !ringSettings?.enabled) {
                redirectToPromotionalWebsite(event, search);
                return;
            }

            // This checks if the user has access to the ring application
            const authCookieAccessName = `${ApiConfig.authCookieAccess}-${event.groupId}`;
            const accessToken = Cookie.get(authCookieAccessName);
            if (!accessToken) {
                try {
                    await refreshTokenRequest(event.groupId);
                } catch (e) {
                    if (!embedMode) {
                        redirectToPromotionalWebsite(event, search);
                        return;
                    }
                    return;
                }
            }

            setIsAuth(true);
        };

        checkAuth();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [event?.id, event, isLoading, ringSettings?.enabled, ringSettings?.available]);

    return isAuth;
};

export default useAuth;
